import { render, staticRenderFns } from "./BulkUpload.vue?vue&type=template&id=35dbd162&scoped=true"
import script from "./BulkUpload.vue?vue&type=script&lang=js"
export * from "./BulkUpload.vue?vue&type=script&lang=js"
import style0 from "./BulkUpload.vue?vue&type=style&index=0&id=35dbd162&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dbd162",
  null
  
)

export default component.exports